export default function getHeightOfMinutes(minutes) {
  return minutes * 960 / 1440;
}